import React, {ReactElement} from "react";
import {Navigate, Route} from "react-router-dom";
import AdventurersHome from "../../pages/cga/home/AdventurersHome";
import AdventurersCharactersPage from "../../pages/cga/character/AdventurersCharactersPage";
import AdventurersCharacterDisplayPage from "../../pages/cga/character/display/AdventurersCharacterDisplayPage";
import AdventurersContactPage from "../../pages/cga/contact/AdventurersContactPage";
import CgaErrorPage from "../../pages/cga/500/CgaErrorPage";
import CgaMissingPage from "../../pages/cga/400/CgaMissingPage";

class AdventurersRouter {

    public static getRoutes(baseRoute: string): ReactElement {
        return (
            <Route path={baseRoute}>
                <Route index element={<AdventurersHome/>}/>
                <Route path="home" element={<Navigate replace to={baseRoute}/>}/>
                <Route path="characters">
                    <Route index element={<AdventurersCharactersPage/>}/>
                    <Route path=":name" element={<AdventurersCharacterDisplayPage/>}/>
                </Route>
                <Route path="contact">
                    <Route index element={<AdventurersContactPage/>}/>
                </Route>
                <Route path="error" element={<CgaErrorPage/>}/>
                <Route path="404" element={<CgaMissingPage/>}/>
                <Route path="*" element={<Navigate replace to={`${baseRoute}/404`}/>}/>
            </Route>
        );
    }
}

export default AdventurersRouter;